// Emoji personnalisé Discord : <:nom:123456789> ou <a:nom:123456789> pour un emoji animé.
// Ce n'est pas du texte mais une IMAGE hébergée sur le CDN Discord ; affiché tel quel, le
// lecteur ne voyait qu'un code entre chevrons.
const CUSTOM_EMOJI_REGEX = /<(a?):([a-zA-Z0-9_]+):(\d+)>/g

function escapeAttribute(value) {
	return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

function convertDiscordMarkdownToHTML(text) {
	// ⚠️ En PREMIER : la syntaxe des emojis contient des chevrons, et les convertir avant les
	// autres règles évite qu'un remplacement intermédiaire ne la disloque.
	text = String(text == null ? '' : text).replace(CUSTOM_EMOJI_REGEX, (match, animated, name, id) => {
		const extension = animated ? 'gif' : 'png'
		const alt = escapeAttribute(`:${name}:`)
		return `<img class="discord-emoji" src="https://cdn.discordapp.com/emojis/${id}.${extension}?size=48" alt="${alt}" title="${alt}" />`
	});

	// Replace bold markdown
	text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

	// Replace italic markdown
	text = text.replace(/\*(.*?)\*/g, '<i>$1</i>');

	// Replace underline markdown
	text = text.replace(/__(.*?)__/g, '<u>$1</u>');

	// Replace strikethrough markdown
	text = text.replace(/~~(.*?)~~/g, '<del>$1</del>');

	// Replace code markdown
	text = text.replace(/```(.*?)```/gs, '<pre>$1</pre>');

	// Replace inline code block markdown
	text = text.replace(/`(.*?)`/g, '<code>$1</code>');

	// Replace spoiler markdown
	text = text.replace(/\|\|(.*?)\|\|/g, '<span class="spoiler">$1</span>');

	// Return converted HTML
	return text;
}

export default convertDiscordMarkdownToHTML